export const environment = {
  production: false,
  mode: 'development',

  backendUri: 'https://api.edro.feelity.dev',
  backendOAuthClientId: '7_4741b908-d9fd-4af5-a0fe-4024091ffad3',
  backendOAuthClientSecret: '1b498985-9030-451d-b8fe-7833b7509c60',

  videoBaseUri: 'https://s3.fr-par.scw.cloud/acwa.connect.video/',

  configurateurUri: 'https://www.e-dro.io/configurateur-app/',
  configurateurProductUri: 'https://www.e-dro.io/configurateur-app/products/',
};
